export * from '@cipafacil/version/cipafacil-version';
export * from '@cipafacil/version/version';
